// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InvoiceTermsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvoiceTermsQuery = { __typename?: 'Query', invoiceScheduleTemplates: Array<{ __typename?: 'InvoiceScheduleTemplate', createdAt: Types.Scalars['DateTime']['input'], id: string, name: string, customer?: { __typename?: 'Customer', id: string, name: string } | null | undefined, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string }, communityType?: { __typename?: 'CommunityTypeDetail', code: Types.CommunityType, name: string } | null | undefined, regions: Array<{ __typename?: 'Region', id: string, name: string }> }> };

export type InvoiceTerms_InvoiceScheduleTemplatesFragment = { __typename?: 'InvoiceScheduleTemplate', createdAt: Types.Scalars['DateTime']['input'], id: string, name: string, customer?: { __typename?: 'Customer', id: string, name: string } | null | undefined, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string }, communityType?: { __typename?: 'CommunityTypeDetail', code: Types.CommunityType, name: string } | null | undefined, regions: Array<{ __typename?: 'Region', id: string, name: string }> };

export const InvoiceTerms_InvoiceScheduleTemplatesFragmentDoc = gql`
    fragment InvoiceTerms_InvoiceScheduleTemplates on InvoiceScheduleTemplate {
  ...Named
  customer {
    ...Named
  }
  lotType {
    code
    name
  }
  communityType {
    code
    name
  }
  regions {
    ...Named
  }
  createdAt
}
    ${NamedFragmentDoc}`;
export const InvoiceTermsDocument = gql`
    query InvoiceTerms {
  invoiceScheduleTemplates {
    ...InvoiceTerms_InvoiceScheduleTemplates
  }
}
    ${InvoiceTerms_InvoiceScheduleTemplatesFragmentDoc}`;

/**
 * __useInvoiceTermsQuery__
 *
 * To run a query within a React component, call `useInvoiceTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoiceTermsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InvoiceTermsQuery, InvoiceTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoiceTermsQuery, InvoiceTermsQueryVariables>(InvoiceTermsDocument, options);
      }
export function useInvoiceTermsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoiceTermsQuery, InvoiceTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoiceTermsQuery, InvoiceTermsQueryVariables>(InvoiceTermsDocument, options);
        }
// @ts-ignore
export function useInvoiceTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsQuery, InvoiceTermsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoiceTermsQuery, InvoiceTermsQueryVariables>;
export function useInvoiceTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsQuery, InvoiceTermsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoiceTermsQuery | undefined, InvoiceTermsQueryVariables>;
export function useInvoiceTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsQuery, InvoiceTermsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoiceTermsQuery, InvoiceTermsQueryVariables>(InvoiceTermsDocument, options);
        }
export type InvoiceTermsQueryHookResult = ReturnType<typeof useInvoiceTermsQuery>;
export type InvoiceTermsLazyQueryHookResult = ReturnType<typeof useInvoiceTermsLazyQuery>;
export type InvoiceTermsSuspenseQueryHookResult = ReturnType<typeof useInvoiceTermsSuspenseQuery>;
export type InvoiceTermsQueryResult = ApolloReactCommon.QueryResult<InvoiceTermsQuery, InvoiceTermsQueryVariables>;